import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CNPrescription } from 'src/app/models/cnprescription';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';
import { BecareService } from 'src/app/services/becare.service';
import { PatientService } from 'src/app/services/patient.service';

@Component({
  selector: 'app-prescription-output-dialog',
  templateUrl: './prescription-output-dialog.component.html',
  styleUrls: ['./prescription-output-dialog.component.scss']
})
export class PrescriptionOutputDialogComponent implements OnInit {

  public prescription: CNPrescription;
  public barcodes: string[] = [];
  public entries: CNPrescriptionEntry[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: {prescription: CNPrescription},
              private patient: PatientService, private becare: BecareService) {
    this.prescription = data.prescription;
  }

  ngOnInit(): void {
    // Get barcode for rid
    // tslint:disable-next-line:max-line-length
    this.prescription.childs$('SNItem.CNItem.CNPrescriptionEntry').forEach(entry => {
      if ((entry as CNPrescriptionEntry).entrytype === 'medication') {
        // tslint:disable-next-line:max-line-length
        this.becare.call('fr/patient/' + this.patient.patientid + '/prescription/' + this.prescription.id + '/entry/' + entry.id + '/barcode').subscribe(result => {
          if (typeof(result.image) !== 'undefined') {
            this.barcodes.push(result.image);
            this.entries.push(entry as CNPrescriptionEntry);
          }
        });
      }
    });
  }

  public print(type: string) {
    console.log('print prescription');
    switch (type) {
      case 'paper':
        {
          const ids = {
            ids: [
              {
                id: this.patient.patientid,
                name: 'patient'
              }, {
                id: this.prescription.id,
                name: 'contact',
                withchilds: true,
                childsdepth: 2
              }, {
                id: this.becare.userid,
                name: 'user'
              }
            ]
          };
          this.becare.call('/fr/template/name/OrdonnanceElec/document/pdf', [], ids, 'post').subscribe(result => {
            console.log(result);
          });
        }
        break;
      case 'digital':
        {
          const ids = {
            ids: [
              {
                id: this.patient.patientid,
                name: 'patient'
              }, {
                id: this.prescription.id,
                name: 'contact',
                withchilds: true,
                childsdepth: 2
              }, {
                id: this.becare.userid,
                name: 'user'
              }
            ]
          };
          this.becare.call('/fr/template/name/OrdonnanceElec/document/pdf', [], ids, 'post').subscribe(result => {
            console.log(result);
          });
        }
        break;
    }
  }
}
